// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import LoadingOutlinedSvg from "@ant-design/icons-svg/lib/asn/LoadingOutlined";
import AntdIcon from "../components/AntdIcon";
const LoadingOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: LoadingOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    LoadingOutlined.displayName = "LoadingOutlined";
}
export default /*#__PURE__*/ React.forwardRef(LoadingOutlined);
